
import {stringifyQuery} from '@/utils'
export default {
  methods: {
    pushPlay (query) {
      let location = window.location.href.slice(0, window.location.href.indexOf('#'))
      let win = window.open(`${location}#/play${stringifyQuery(query)}`, '课程播放', 'width=' + window.screen.width + ',height=' + window.screen.height + ',top=0,left=0,toolbar=no, menubar=no, scrollbars=yes, resizable=no,location=no, status=no')
      win.vm = this
    },
    update (userLearningFlowID, currentTime) {
      this.$ajax({
        url: 'api-course/portal/userLearningFlow',
        method: 'PUT',
        data: {
          userLearningFlowID: userLearningFlowID,
          playEndTime: (currentTime ? parseInt(currentTime) : '')
        }
      }).then(() => {
        this.$$forceRender && typeof this.$$forceRender === 'function' && this.$$forceRender()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/play.js